import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { useBoolean, useRecentGetter } from '@lib/common';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSubject } from '@lib/common/hooks/use-subject';
import fuzzysort from 'fuzzysort';
import { useSubscription } from '@lib/common/hooks/use-subscription';
import { debounceTime, switchMap } from 'rxjs/operators';
import { asyncScheduler } from 'rxjs';
import { MediaDialogContent } from './MediaDialogContent_v2';
import { ContentMedia } from '@lib/content';
import { rbac } from '@lib/common';

export const MediaPicker = ({
  onMediaAdd = null,
  onMediaEdit = null,
  MediaEditState = false,
  editMediaScenario = false,
  editMediaIndex = null,
  editMediaData = null,
  setEachMediaEdit = null,
}: {
  onMediaAdd?: (Media: ContentMedia) => any;
  onMediaEdit?: (Media: ContentMedia, idx?: number) => any;
  MediaEditState?: boolean;
  editMediaScenario?: boolean;
  editMediaIndex?: number;
  editMediaData?: ContentMedia;
  setEachMediaEdit?: (editingBadge: boolean) => any;
}) => {
  const [dialogOpen, openDialog, closeDialog] = useBoolean(false);
  useEffect(() => {
    if (MediaEditState) openDialog();
  }, [MediaEditState]);

  const saveMediaClick = (Media: ContentMedia) => {
    closeDialog();
    setTimeout(() => {
      if (editMediaScenario)
        onMediaEdit &&
          onMediaEdit(
            {
              video_name: Media.video_name,
              video_site: Media.video_site,
              path: Media.path,
              video_type: Media.video_type,
              language_id: Media.language_id,
              vtr_id: Media.vtr_id,
            },
            editMediaIndex
          );
      else
        onMediaAdd &&
          onMediaAdd({
            video_name: Media.video_name,
            video_site: Media.video_site,
            path: Media.path,
            video_type: Media.video_type,
            language_id: Media.language_id,
            vtr_id: Media.vtr_id,
          });
      setOkPressed(false);
    }, 100);
  };
  const [OkPressed, setOkPressed] = useState(false);
  return (
    <>
      {!editMediaScenario && (
        <Button
          onClick={openDialog}
          // disabled={rbac('Content_AddContentMedia', '', 'Button')}
          color="primary"
          variant="contained">
          Add
        </Button>
      )}
      <Dialog
        // Disable transitions to speed up the element interaction
        // and fix multiple addtion on consecutive clicks.
        transitionDuration={0}
        fullWidth
        maxWidth="sm"
        open={dialogOpen}
        onClose={() => {
          setEachMediaEdit && setEachMediaEdit(false);
          closeDialog();
        }}>
        <DialogTitle>Add/Edit Content Media</DialogTitle>
        <DialogContent style={{ height: '65vh' }} dividers>
          <MediaDialogContent
            saveMedia={saveMediaClick}
            defaultValue={editMediaData}
            OkPressed={OkPressed}
            setOkPressed={setOkPressed}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOkPressed(true)}>Ok</Button>
          <Button
            onClick={() => {
              setEachMediaEdit && setEachMediaEdit(false);
              closeDialog();
            }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
